import { useState, useEffect } from "react";
import { Button, Container, Nav, Navbar, Image } from "react-bootstrap";
import logo from "../../assets/images/Qompas-logo.png";
import NotificationModal from "../modal/modal";

function Navigation() {
  const [modalNotify, setModalNotify] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <NotificationModal
        show={modalNotify}
        onHide={() => setModalNotify(false)}
      />

      <Navbar
        collapseOnSelect
        expand="lg"
        className={`fixed-top transition-all duration-300 ${scrolled ? "navbar-custom py-2" : "bg-transparent py-4"
          }`}
      >
        <Container>
          <Navbar.Brand href="#home">
            <Image src={logo} height={40} className="d-inline-block align-top" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" className="border-0 shadow-none" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mx-auto align-items-center">
              {['Home', 'About Us', 'Features', 'Team', 'Contact Us'].map((item) => (
                <Nav.Link
                  key={item}
                  href={`#${item.toLowerCase().replace(' ', '')}`}
                  className="mx-3 fw-medium text-dark position-relative hover-underline"
                  style={{ fontSize: '0.95rem' }}
                >
                  {item}
                </Nav.Link>
              ))}
            </Nav>

            <Nav className="align-items-center mt-3 mt-lg-0">
              <Nav.Link
                onClick={() => setModalNotify(true)}
                className="me-3 fw-semibold text-primary d-none d-lg-block"
              >
                Login
              </Nav.Link>
              <Button
                className="btn-primary-custom"
                onClick={() => setModalNotify(true)}
              >
                Get Started
              </Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default Navigation;
